import { memo} from 'react'; 
import { Handle, Position } from '@xyflow/react';


import { BuildingStorefrontIcon } from '@heroicons/react/20/solid';
import { UserIcon } from '@heroicons/react/20/solid';


function CustomNode({ data }) {
  console.log(data)
  return (
    data.role !== "adminVente" ? (
      <a href={`/${data.role}/${data.id}`}>
        <div className="px-4 py-2 shadow-md rounded-md bg-white dark:bg-gray-900 border-2 border-stone-400 max-w-[230px]">
          <div className="flex">
            
            <div className="rounded-full w-12 h-12 flex justify-center items-center bg-gray-100">
              {data.role === "franchise" || data.role === "pdv" ? (
                <BuildingStorefrontIcon className="h-6 w-6 text-gray-500" />
              ) : (
                <UserIcon className="h-6 w-6 text-gray-500" />
              )}
            </div>
            <div className="ml-2">
              <div className="text-md font-semi-bold dark:text-white">{data?.role.toUpperCase()}</div>
              {data.Name && (<div className="text-lg font-bold dark:text-white">{data.Name}</div>)}
              {data.FirstName && (<div className="text-lg font-bold">{data.FirstName + " " + data.LastName}</div>)}
              <div className="text-gray-500 dark:text-gray-300">{"Stock : " + data.StockTotal}</div>
            </div>
          </div>
          <Handle
            type="target"
            position={Position.Top}
            className="w-16 !bg-teal-500"
          />
          <Handle
            type="source"
            position={Position.Bottom}
            className="w-16 !bg-teal-500"
          />
        </div>
      </a>
    ) : (
      
      <div className="px-4 py-2 shadow-md rounded-md bg-white dark:bg-gray-900 border-2 border-stone-400">
      <div className="flex">

        <div className="rounded-full w-12 h-12 flex justify-center items-center bg-gray-100">
          <UserIcon className="h-6 w-6 text-gray-500" />
        </div>
        <div className="ml-2">
          {data.Name && (<div className="text-lg font-bold dark:text-white">{data.Name}</div>)}
          {data.FirstName && (<div className="text-lg font-bold">{data.FirstName + " " + data.LastName}</div>)}
          <div className="text-gray-500 dark:text-gray-300">{"Stock : " + data.StockTotal}</div>
        </div>
      </div>
      <Handle
        type="target"
        position={Position.Top}
        className="w-16 !bg-teal-500"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className="w-16 !bg-teal-500"
      />
    </div>  
    )
  );
  
}

export default memo(CustomNode);
